webpackJsonp([116229058454702,175145265529644,41987919009899,8267127257773],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = HeroIllustration;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _generalModule = __webpack_require__(252);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _illustrationModule = __webpack_require__(251);
	
	var _illustrationModule2 = _interopRequireDefault(_illustrationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _generalModule2.default, _illustrationModule2.default));
	
	function HeroIllustration(_ref) {
	  var children = _ref.children,
	      color = _ref.color,
	      copy = _ref.copy,
	      headingMaxWidth = _ref.headingMaxWidth,
	      imageMaxWidth = _ref.imageMaxWidth,
	      _ref$isContactUsPage = _ref.isContactUsPage,
	      isContactUsPage = _ref$isContactUsPage === undefined ? false : _ref$isContactUsPage,
	      src = _ref.src,
	      title = _ref.title,
	      tag = _ref.tag;
	
	  var heroClassName = cx('hero');
	  var illustrationClassName = cx('illustration');
	
	  return _react2.default.createElement(
	    'div',
	    { className: heroClassName },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', size: 'xl', position: 'topBottom' },
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 12, alignItems: 'center' },
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 5 },
	            _react2.default.createElement(
	              _align2.default,
	              { type: 'center', typeM: 'left' },
	              _react2.default.createElement(
	                Container,
	                {
	                  isContactUsPage: isContactUsPage,
	                  headingMaxWidth: headingMaxWidth
	                },
	                _react2.default.createElement(
	                  _heading2.default,
	                  { tag: tag, size: 'xxxl', color: color, weight: 'bold' },
	                  title
	                ),
	                copy && _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 'xs', position: 'top' },
	                  _react2.default.createElement(
	                    _paragraph2.default,
	                    { size: 'l', color: color },
	                    copy
	                  )
	                ),
	                children
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 7 },
	            _react2.default.createElement(
	              'div',
	              { className: illustrationClassName },
	              src && _react2.default.createElement(_Image2.default, {
	                alt: title,
	                maxWidth: imageMaxWidth,
	                src: src,
	                hasShadow: false,
	                useImageTag: true
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var validColors = ['white', 'black', 'steel', 'slate', 'silver', 'darkSmoke', 'extraDarkSmoke', 'smoke', 'darkSnow', 'extraDarkSnow', 'snow'];
	
	var validTags = ['h1', 'h2'];
	
	function Container(_ref2) {
	  var isContactUsPage = _ref2.isContactUsPage,
	      children = _ref2.children,
	      headingMaxWidth = _ref2.headingMaxWidth;
	
	  if (isContactUsPage) return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        paddingLeft: '15%',
	        paddingRight: '15%'
	      }
	    },
	    children
	  );
	  return _react2.default.createElement(
	    _maxWidth2.default,
	    { value: headingMaxWidth, display: 'inlineBlock' },
	    children
	  );
	}
	
	Container.propTypes = {
	  isContactUsPage: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  headingMaxWidth: _propTypes2.default.number
	};
	
	HeroIllustration.propTypes = {
	  children: _propTypes2.default.node,
	  copy: _propTypes2.default.string,
	  headingMaxWidth: _propTypes2.default.number,
	  imageMaxWidth: _propTypes2.default.number,
	  isContactUsPage: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  title: _customPropTypesCheck2.default,
	  color: _propTypes2.default.oneOf(validColors),
	  tag: _propTypes2.default.oneOf(validTags)
	};
	
	HeroIllustration.defaultProps = {
	  imageMaxWidth: 660,
	  headingMaxWidth: 460,
	  color: 'black',
	  tag: 'h1'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"illustration":"src-components-modules-Hero-HeroIllustration-style----illustration-module---illustration---OByMU textAlign-center centered"};

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BotBot;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _assets = __webpack_require__(81);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _generalModule = __webpack_require__(161);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BotBot() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2 },
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: 770 },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.botbot, { hasShadow: false, maxWidth: 600 }))
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.botbot, { hasShadow: false, maxWidth: 600 }))
	          ),
	          _react2.default.createElement(
	            _HeadingBlock2.default,
	            {
	              color: 'white',
	              title: 'BotBot \u2013\xA0Slack Bot for creating and managing prototypes',
	              headingMaxWidth: 500,
	              maxWidth: 500,
	              copy: 'Check out our API example BotBot, a bot for creating, viewing and managing prototypes by simply using Slash Commands in Slack. Grab the code and make your own bot!'
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _generalModule2.default.buttons },
	              _react2.default.createElement(
	                'div',
	                { className: _generalModule2.default.margin },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://github.com/marvelapp/BotBot/',
	                    rel: 'noopener noreferrer',
	                    target: '_blank'
	                  },
	                  _react2.default.createElement(
	                    _button2.default,
	                    {
	                      size: 'large',
	                      shape: 'rounded',
	                      color: 'slate',
	                      hover: 'white',
	                      background: 'white'
	                    },
	                    'View on Github'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://botbot.marvelapp.com/',
	                  rel: 'noopener noreferrer',
	                  target: '_blank'
	                },
	                _react2.default.createElement(
	                  _button2.default,
	                  {
	                    size: 'large',
	                    shape: 'rounded',
	                    kind: 'ghost',
	                    hover: 'white',
	                    isReversed: true
	                  },
	                  'Try the demo'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Features;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Feature = __webpack_require__(45);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _assets = __webpack_require__(81);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Features() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    null,
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { sizeM: 'l', position: 'topBottom', type: 'margin' },
	        _react2.default.createElement(_HeadingBlock2.default, {
	          align: 'center',
	          alignContent: 'center',
	          alignM: 'center',
	          color: 'white',
	          copy: 'You can now harness components of our platform and build powerful integrations for our 2 million users - or simply just for your team.',
	          title: 'Experience the freedom to build features, right away.'
	        })
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, size: 'l', sizeM: 'xl' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanM: 1, alignContent: 'center' },
	          _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.team, {
	            title: 'Dedicated API Team',
	            copy: 'Our team are available to answer questions via our Slack Developer Community and Email.',
	            maxWidth: 360,
	            maxImageWidth: 250,
	            fontWeight: 'semibold',
	            alignM: 'center',
	            copyColor: 'silver',
	            headingColor: 'white'
	          }))
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanM: 1, alignContent: 'center' },
	          _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.graphQL, {
	            title: 'Our API uses GraphQL',
	            copy: 'Giving you the flexibility to select all the data you need with a single request.',
	            maxWidth: 360,
	            maxImageWidth: 250,
	            fontWeight: 'semibold',
	            alignM: 'center',
	            copyColor: 'silver',
	            headingColor: 'white'
	          }))
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanM: 1, alignContent: 'center' },
	          _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.workflow, {
	            title: 'Supercharge your workflow',
	            copy: 'Automate workflows, extract designs and analyse data to take Marvel to the next level.',
	            maxWidth: 360,
	            maxImageWidth: 250,
	            fontWeight: 'semibold',
	            alignM: 'center',
	            copyColor: 'silver',
	            headingColor: 'white'
	          }))
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Showcase;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _assets = __webpack_require__(81);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _generalModule = __webpack_require__(161);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Showcase() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2 },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.showcase, { hasShadow: false, maxWidth: 600 }))
	          ),
	          _react2.default.createElement(
	            _HeadingBlock2.default,
	            {
	              color: 'white',
	              title: 'Showcase your app in our integrations directory',
	              copy: 'Building something special? We\u2019re always looking to work with partners who want to help the world bring their ideas to life.',
	              maxWidth: 500
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _generalModule2.default.buttons },
	              _react2.default.createElement(
	                'div',
	                { className: _generalModule2.default.margin },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://marvelapp.typeform.com/to/tT0fpS',
	                    rel: 'noopener noreferrer',
	                    target: '_blank'
	                  },
	                  _react2.default.createElement(
	                    _button2.default,
	                    {
	                      size: 'large',
	                      shape: 'rounded',
	                      color: 'slate',
	                      hover: 'white',
	                      background: 'white'
	                    },
	                    'Become a partner'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/features/integrations' },
	                _react2.default.createElement(
	                  _button2.default,
	                  {
	                    size: 'large',
	                    shape: 'rounded',
	                    kind: 'ghost',
	                    hover: 'white',
	                    isReversed: true
	                  },
	                  'View Integrations'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: 770 },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.showcase, { hasShadow: false, maxWidth: 600 }))
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = DeveloperApi;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _grid = __webpack_require__(5);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _HeroIllustration = __webpack_require__(203);
	
	var _HeroIllustration2 = _interopRequireDefault(_HeroIllustration);
	
	var _assets = __webpack_require__(81);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _Features = __webpack_require__(641);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Showcase = __webpack_require__(642);
	
	var _Showcase2 = _interopRequireDefault(_Showcase);
	
	var _BotBot = __webpack_require__(640);
	
	var _BotBot2 = _interopRequireDefault(_BotBot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DeveloperApi() {
	  var pageProps = {
	    title: _metadata2.default.developers.homepage.title,
	    meta: [{
	      name: 'description',
	      content: _metadata2.default.developers.homepage.description
	    }],
	    header: {
	      isLight: true,
	      title: 'Developers'
	    },
	    footer: true,
	    banner: false
	  };
	
	  var linkProps = {
	    rel: 'noopener noreferrer',
	    target: '_blank'
	  };
	
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(
	      'div',
	      { className: 'bg-licorice' },
	      _react2.default.createElement(
	        _HeroIllustration2.default,
	        _extends({
	          title: 'Let\u2019s build the future of design, together',
	          copy: 'Create amazing tools and integrations for over 2 million users or customise Marvel for your own team.',
	          color: 'white',
	          imageMaxWidth: 760,
	          tag: 'h1'
	        }, _assets2.default.illustration),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'l', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', sizeM: '0', position: 'bottom' },
	            _react2.default.createElement(
	              _grid.InlineGrid,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/developers/documentation/' },
	                _react2.default.createElement(
	                  _button2.default,
	                  {
	                    size: 'large',
	                    color: 'slate',
	                    hover: 'white',
	                    background: 'white',
	                    shape: 'rounded'
	                  },
	                  'View the docs'
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                _extends({ href: '/oauth/applications/' }, linkProps),
	                _react2.default.createElement(
	                  _button2.default,
	                  {
	                    size: 'large',
	                    shape: 'rounded',
	                    kind: 'ghost',
	                    hover: 'white',
	                    isReversed: true
	                  },
	                  'Manage your apps'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Features2.default, null),
	      _react2.default.createElement(_BotBot2.default, null),
	      _react2.default.createElement(_Showcase2.default, null)
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"buttons":"src-pages-developers-style----general-module---buttons---3Z4G1 breakPointS-inline","margin":"src-pages-developers-style----general-module---margin---2_iJx marginBottom-m breakPointS-marginBottom-0 breakPointS-marginRight-m"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-developers-index-js-6316c8f8c82724e5a578.js